export function awalKataKapital(teks: string): string {
  return teks
    .split(/(\s+)/)
    .map((bagian) => (bagian.trim() === "" ? bagian : bagian.charAt(0).toLocaleUpperCase("id-ID") + bagian.slice(1)))
    .join("")
}
